import {
  ARConsoleFormatType,
  ARConsoleModulationType,
  ARConsoleType,
  ARConsoleVersion,
  ARFertilizerType,
} from './agrorendement-common-lists.model';

export class GCFarm {
  id: number;
  name: string;

  parcels: Array<GCParcel> = null;
}

export class GCParcel {
  id: number;
  name: string;

  orderItemId: number;
  farmId: number;

  precoResultId: string;
  dosePreconisee: number;
  doseConsole: number;

  console: GCOrderItemConsole = null;
  group: GCParcelGroup = null;
}

export class GCOrderItemConsole {
  orderItemId: number;

  consoleModulationType: ARConsoleModulationType;
  consoleType: ARConsoleType;
  consoleVersion: ARConsoleVersion;
  otherConsoleVersion: string;
  consoleFormatType: ARConsoleFormatType;

  fertilizerType: ARFertilizerType;
  fertilizerConcentration: number;

  // pour montrer dans l'UI
  name: string;
  parcelId: number;
}

export class GCParcelGroup {
  parcelId: number;
  name: string;

  groupName: string;
}
